module.exports = __webpack_public_path__ + "static/media/limchukang-back.5168177d.png";